import logo from "../../assets/icons/logo.svg";
import chevronDown from "../../assets/icons/chevron-down.svg";
import avatar from "../../assets/icons/avatar.svg";
import notification from "../../assets/icons/notification.svg";
import search from "../../assets/icons/search.svg";
import close from "../../assets/icons/close.svg";
import help from "../../assets/icons/help.svg";
import settings from "../../assets/icons/settings.svg";
import otherApps from "../../assets/icons/menu.svg";
import PropTypes from "prop-types";
import "./Header.scss";
import React, { useState } from "react";
// import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { DebounceInput } from "react-debounce-input";
import Popover from "@material-ui/core/Popover";
// import { Context } from "../../context/AppContext";
import { AUTH_LOGOUT_REQUEST } from "../../actions/auth";
import {useTranslation} from "react-i18next";

const Header = (props) => {
  const { t, i18n } = useTranslation();
  // const {mainMenuItems } = useContext(Context);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const dispatch = useDispatch();
  const [anchorOtherApps, setAnchorOtherApps] = useState(null);
  const [anchorLogOut, setAnchorLogOut] = useState(null);

  const general = useSelector((state) => state.general, shallowEqual);

  // const { headerMenuList } = general;

  const username = sessionStorage.getItem("username");
  const sessionId = sessionStorage.getItem("s_id");

  // useEffect(() => {
  //   dispatch({
  //     type: GET_HEADER_MENU_LIST,
  //     payload: {
  //       username,
  //       session_id: sessionId,
  //     },
  //   });
  // }, []); //eslint-disable-line

  const toggleNotifications = () => {
    setIsNotificationsOpen(!isNotificationsOpen);
  };

  const {
    text,
    roles,
    searchText,
    setSearchText,
  } = props;

  const isOpen = searchText.length > 0;

  const searchTickets = (e) => {
    setSearchText(e.target.value);
  };

  const clearSearch = () => {
    setSearchText("");
  };

  const translate = () => {
    if (!localStorage.getItem('i18nextLng')) {
      localStorage.setItem('i18nextLng', 'ar');
      i18n.changeLanguage('ar');
    } else if (localStorage.getItem('i18nextLng') === 'en') {
      localStorage.setItem('i18nextLng', 'ar');
      i18n.changeLanguage('ar');
    } else {
      localStorage.setItem('i18nextLng', 'en');
      i18n.changeLanguage('en');
    }
  }

  return (
    <div className={classnames("board-header", {rightCtl: i18n.language === 'ar'})}>
      <div className={classnames("section", "left")}>
        <div className='icon-buttons has-border-right'>
        </div>
        <img className='logo' src={logo} alt='' />
        <div className='logo-text'>
          <span>{t('Mashhad')}</span>
          <h2>{t(text)}</h2>
        </div>
      </div>
      <div className={classnames("section", "middle")}>
        {/* <div className='search'>
          <img className='hourglass' src={search} alt='' />
          <DebounceInput
            type='text'
            debounceTimeout={500}
            onChange={(e) => searchTickets(e)}
            value={searchText}
            placeholder={t('Search')}
          />
          <img
            className={classnames("close", { active: isOpen })}
            src={close}
            onClick={clearSearch}
            alt=''
          />
        </div> */}
      </div>
      <div className={classnames("section", "right")}>
        <div className='icon-buttons'>
          <div className='icon-button has-separator' onClick={translate}>
            {!localStorage.getItem('i18nextLng') ? 'ar' : localStorage.getItem('i18nextLng') === 'en' ? 'ar' : 'en'}
          </div>
        </div>
        <div
          className='dropdown'
          onClick={(e) => setAnchorLogOut(e.currentTarget)}>
          <img className='avatar' src={avatar} alt='' />
          <div className='name-holder'>
            <p className='big'>{username ? username : "Test User"}</p>
            <p className='small'>{roles ? roles[0] : t("Manager")}</p>
          </div>
          <img src={chevronDown} alt='' />
        </div>
        <Popover
          className='logout-menu'
          anchorEl={anchorLogOut}
          open={Boolean(anchorLogOut)}
          onClose={() => setAnchorLogOut(null)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}>
          <div className='logout-item'>
            <p
              onClick={() => {
                dispatch({ type: AUTH_LOGOUT_REQUEST })
              }}
            >
              {t("LOGOUT")}
            </p>
          </div>
        </Popover>
      </div>
    </div>
  );
};

Header.defaultProps = {
  text: "",
  auth: {},
  roles: [],
  notifications: [],
  searchText: "",
  setSearchText: null,
  filtersState: {},
};

Header.propTypes = {
  text: PropTypes.string,
  name: PropTypes.object,
  filtersState: PropTypes.object,
  roles: PropTypes.array,
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      time: PropTypes.string,
      buttons: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          onClick: PropTypes.func,
        })
      ),
    })
  ),
  searchText: PropTypes.string,
  setSearchText: PropTypes.func,
};

export default Header;
